import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgOrganizationChartNodeModel } from 'ng-organization-chart/ng-organization-chart-node-model';
import { Helper } from 'src/app/shared/Helper';
import { AlertService } from 'src/app/shared/providers/AlertProvider';
import { REPORTS } from '../../shared/models/mock-data';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  reports: any[];

  reportsTree: NgOrganizationChartNodeModel[] = [];

  constructor(private helper: Helper,
    private router: Router, public alertService: AlertService) {
    this.reports = REPORTS as any[];
    this.reportsTree = this.helper.createTree({ idKey: "Id", parentKey: "Parent_Id" }, this.reports);
  }

  ngOnInit() {

  }

  OpenReport(reportname: string, reportid: number) {
    debugger
    switch (reportid) {
      case 3:
        this.router.navigateByUrl('/hubAdmin/bud4trade-report');
        break;
      case 4:
        this.router.navigateByUrl('/hubAdmin/mystery-report');
        break;
      case 11:
        this.router.navigateByUrl('/hubAdmin/redmeption-report');
        break;
      case 12:
        this.router.navigateByUrl('/hubAdmin/target-achievement-report');
        break;
      case 13:
        this.router.navigateByUrl('/hubAdmin/complied-state-report');
        break;
      case 14:
        this.router.navigateByUrl('/hubAdmin/end-of-month-report');
        break;
      case 15: this.router.navigateByUrl('/hubAdmin/live-report');
        break;
      case 17: this.router.navigateByUrl('/hubAdmin/engagement-time-report');
        break;
      case 16: this.router.navigateByUrl('/hubAdmin/dau-time-report');
        break;
      case 18:
        this.router.navigateByUrl('/hubAdmin/mau-time-report'); break;
      case 19:
        this.router.navigateByUrl('/hubAdmin/module-time-report'); break;
      case 19:
        this.router.navigateByUrl('/hubAdmin/scheme-report'); break;
      case 20:
        this.router.navigateByUrl('/hubAdmin/uplift-report'); break;
      case 21:
        this.router.navigateByUrl('/hubAdmin/leaderborad-report'); break;
      case 10:
        this.router.navigateByUrl('/hubAdmin/other-report'); break;
      case 23:
        this.router.navigateByUrl('/hubAdmin/user-report');
        break;
      case 24:
        this.router.navigateByUrl('/hubAdmin/mobile-change-report');
        break;
      case 25:
        this.router.navigateByUrl('/hubAdmin/enrollment-detailed-report');
        break;
      case 26:
        this.router.navigateByUrl('/hubAdmin/account-statement');
        break;
      case 27:
        this.router.navigateByUrl('/hubAdmin/enagement-statement');
        break;
      case 28:
        this.router.navigateByUrl('/hubAdmin/redemption-hub-report');
        break;
      case 29:
        this.router.navigateByUrl('/hubAdmin/scheme-report');
        break;
      case 30:
      this.router.navigateByUrl('/hubAdmin/point-statement-report');
      break;
      case 32:
      this.router.navigateByUrl('/hubAdmin/carton-insert-report');
      break;
      case 33:
      this.router.navigateByUrl('/hubAdmin/outlet-master-report');
      break;
      case 34:
        this.router.navigateByUrl('/hubAdmin/points-ledger-report');
        break;
      case 35:
        this.router.navigateByUrl('/hubAdmin/otp-sms-consumption');
      break;
      case 36:
        this.router.navigateByUrl('/hubAdmin/user-login-history-report');
      break;
      
      default:
        this.alertService.info("Report Under Development");
        this.clearSuccess();
        break;
    }
  }

  clearSuccess() {
    setTimeout(() => {
      this.alertService.clear(); // stop foreground spinner of the master loader with 'default' taskId
    }, 4000);
  }

}
